<template>
  <div class="invoice-overlay">
    <div class="invoice-content">
      <h1>faktura</h1>
      <p>Jeśli chcesz otrzymać fakturę za zrealizowane doładowanie wejdź na stronę <a href="https://faktury.autopay.pl" target="_blank" rel="noreferrer">https://faktury.autopay.pl</a> i postępuj zgodnie z instrukcjami.</p>
      <p>Jeśli jeszcze nie zasiliłeś konta nju - doładuj swój numer i w ostatnim kroku wybierz opcję "faktura".</p>
      <div class="invoice-button">
        <button class="btn" type="button" @click="close">Zamknij</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'TopupInvoice',
  methods: {
    ...mapMutations([
      'toggleInvoiceInfoVisible'
    ]),
    close () {
      this.toggleInvoiceInfoVisible()
    }
  }
}
</script>

<style src="../../assets/scss/topup-invoice.scss" lang="scss"></style>
